import axios, { AxiosError } from "axios";
import applyCaseMiddleware from "axios-case-converter";

const baseApiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "http://localhost:3000",
  headers: {
    "Content-Type": "application/json",
  },
});

baseApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

baseApiClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (error instanceof AxiosError && error.response?.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.href = "/sign-in";
    }
    return Promise.reject(error instanceof Error ? error : new Error(String(error)));
  },
);

// Preserve dot-notation keys (e.g., prompt template variable names like
// "recommendation.direction") so they aren't camelCased into "recommendationDirection".
// Normal snake_case API fields don't contain dots, so this predicate only skips
// the template-variable namespace.
export const apiClient = applyCaseMiddleware(baseApiClient, {
  preservedKeys: (input: string) => input.includes("."),
});
